<script>
  import config from '../../libs/config.json';
	import { mapGetters, mapActions } from 'vuex'
	
	export default 
	{
		name: 'OnboardingInbox',
		data() 
        {
        	return {}
        },
        computed: {
          ...mapGetters('session', ['getUser'])
        },
      methods: {
        ...mapActions('session', ['setUser']),
        ...mapActions('htmlModals', ['setOnboardingInbox'])
      },
        created(){
        }
	}
</script>

<template>
<div  style="position: fixed; top: 0; right: 0; bottom: 0; left:0; background: rgba(255, 255, 255, 0.6) none repeat scroll 0% 0%; z-index: 9999; overflow: scroll;"
v-cloak>
    <div style="margin-top: 30px;" class="ui container">
        <div data-aos="fade-zoom-in" class="twelve wide computer sixteen wide mobile column centered">
            <div class="ui grid stackable">
                <div style="background: #fbfbfb;box-shadow: 0px 2px 54px rgba(39, 39, 39, 0.30);padding: 0; border-radius:5px;" class="eight wide computer sixteen wide mobile centered column">
                    <img style="border-radius:5px 5px 0 0;" class="ui fluid image" :src="'/img/inbox_pre.png'" alt="">
                    <div style="margin-top: 0;" class="ui basic padded large segment">
                    <h2>Social Inbox 🧐 </h2>
                    <p>Social Inbox is basically a container that holds all of your social account's conversations in one place. You're going to engage with all of your social audience through social inbox.</p>
                    <p>All new received messages make the conversation's status Pending! Thus, you never miss a customer message, If all conversations had Solved by support team, it's mean that inbox zero :)</p>
                    <p>Tagging and assigning the conversations to the related departments or users makes your life easier.</p>
                    <div @click="setOnboardingInbox(false)" class="ui button green fluid">Gotcha!</div>
                    </div>
                </div>
            </div>
        </div>
    </div>      
</div>      
</template>




// WEBPACK FOOTER //
// src/components/dashboard/OnboardingInbox.vue